import React, { ReactNode } from 'react'

export const Panel = ({ children }: { children: ReactNode }) => {
  return (
    <div className="p-8 bg-panel border-panelborder border-[1px]">
      {children}
    </div>
  )
}
